import { Logo } from "@tvg/fuse/logo";
import React from "react";
import styles from "./Header.module.css";

export interface HeaderLogoProps {
  brand: string;
}

const HeaderLogo: React.FC<HeaderLogoProps> = ({ brand }) => {
  switch (brand) {
    case "littlewoods":
      return (
        <div className={styles.header__logoWrapper}>
          <Logo
            className={`${styles.header__littlewoodsDesktopLogo} navi-header-logo__littlewoods-desktop`}
            brand="LittlewoodsStrip"
            alt={`${brand} logo`}
            dataTestId="header-logo"
            href="/"
          />

          <Logo
            className={`${styles.header__littlewoodsMobileLogo} navi-header-logo__littlewoods-mobile`}
            brand="LittlewoodsRoundBasic"
            alt={`${brand} logo`}
            dataTestId="header-logo"
            href="/"
            size={{ width: "4.8rem" }}
          />
        </div>
      );
    default:
      return (
        <div className={styles.header__logoWrapper}>
          <Logo
            className={`${styles.header__veryLogo} navi-header-logo__very`}
            brand="VeryPrimary"
            alt={`${brand} logo`}
            dataTestId="header-logo"
            href="/"
            size={{
              xxs: { height: `4.8rem`, width: `auto` },
              l: { height: `6.4rem`, width: `auto` },
            }}
          />
        </div>
      );
  }
};

export default HeaderLogo;
